import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'

export default (app) => {
  app.use(VueTippy, {
    directive: 'tooltip',
    component: 'tooltip',
    zIndex: 99999900,
    flipDuration: 0,
    arrow: 'true',
    animation: 'fade',
    defaultProps: {
      placement: 'auto-end',
      allowHTML: true,
      interactive: true,
      hideOnClick: false
    }
  })
}

// import Vue from 'vue';
// import VueTippy, { TippyComponent } from 'vue-tippy';

// Vue.use(VueTippy, {
//   a11y: false,
//   zIndex: 200,
//   directive: 'tooltip',
//   flipDuration: 0,
//   theme: 'light',
//   arrow: 'true',
//   animation: 'fade',
//   popperOptions: {
//     modifiers: {
//       preventOverflow: {
//         enabled: true,
//         boundariesElement: 'viewport'
//       }
//     }
//   }
// })

// Vue.component('tooltip', TippyComponent);
